module.exports = __webpack_public_path__ + "img/canada-mental-and-behavioural-disorders-female.8de6754d.png";